// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"8c13f346c2130c52","660":"3ed13c27b322abb6"}[chunkId] + ".css";
};